import { Flex, FlexProps, hooks, Text } from '@bitrise/bitkit';
import React, { FunctionComponent } from 'react';

interface Props extends FlexProps {
  title: string;
}

const OverviewTitle: FunctionComponent<Props> = ({ children, direction, title, ...rest }) => {
  const match = hooks.useMediaQuery(['564px', '1200px']);
  const flexDirection = direction || (match('1200px') ? 'horizontal' : 'vertical');

  return (
    <Flex {...rest} direction={flexDirection} margin="x8" gap="x8">
      <Flex grow={flexDirection === 'horizontal'}>
        <Text config="5" align={!match('564px') ? 'middle' : undefined}>
          {title}
        </Text>
      </Flex>

      {children && <Flex>{children}</Flex>}
    </Flex>
  );
};

export default OverviewTitle;
